import {
  FETCH_PRODUCT_STATUS,
  FETCH_PRODUCT_STATUS_SUCCESS,
  FETCH_TEST_TOKEN_FROM_PROD,
  FETCH_TEST_TOKEN_FROM_PROD_SUCCESS,
  RESEND_EMAIL_VERIFICATION,
  RESEND_EMAIL_VERIFICATION_SUCCESS,
  ACTIVATE_PRODUCTS,
  VALIDATE_TOKEN,
  VALIDATE_TOKEN_SUCCESS,
  ENABLE_LOADER,
  DISABLE_LOADER,
  FETCH_GAMMA_TOKEN,
  UPDATE_GAMMA_TOKEN,
  FETCH_PAYOUT_DASHBOARD_CONFIG,
  FETCH_PAYOUT_DASHBOARD_CONFIG_SUCCESS,
  REDEEM_VOUCHER,
  GET_SUBSCRIPTION_STATUS,
  UPDATE_SUBSCRIPTION_STATUS,
  SUBSCRIBE_WHATSAPP,
  WHATSAPP_CONSENT,
  FRESHDESK_REDIRECT,
  FETCH_BANNERS,
  GET_MERCHANT_DETAILS,
  FETCH_PRODUCT_CARDS,
  QUICK_ACTIVATE_PRODUCT,
  PARTNER_CONSENT,
  PARTNER_TNC,
  GET_ACCOUNT_MANAGER_DETAILS,
  SET_ACCOUNT_MANAGER_DETAILS,
  ACTIVATE_ECOM_PRODUCT_ACTION,
  FETCH_AGGREGATED_PRODUCT_STATUS,
  FETCH_QUICK_LINKS,
  FETCH_QUICK_LINKS_SUCCESS,
  FETCH_HELPCENTER_FORM,
  FETCH_HELPCENTER_FORM_SUCCESS,
  FETCH_HC_FORM_DATA_SUCCESS,
  OPEN_HC_FORM,
  CLOSE_HC_FORM,
  CLOSE_BANNER,
  PAYOUT_PROTECT_INSIGHTS,
  PAYOUT_PROTECT_ACTIVE_STATUS,
  PAYOUT_PROTECT_INSIGHTS_SUCCESS,
  PAYOUT_PROTECT_ACTIVE_STATUS_SUCCESS,
  ACTIVATE_PAYOUT_PROTECT,
  RISK_SHIELD_ACTIVE_STATUS,
  RISK_SHIELD_ACTIVE_STATUS_SUCCESS,
  ACTIVATE_RISKSHIELD,
  FEATURE_REQUEST_STATUS,
} from './constants';

export function fetchProductStatus() {
  return {
    type: FETCH_PRODUCT_STATUS,
  };
}

export function getSubscriptionStatus(envCall) {
  return {
    type: GET_SUBSCRIPTION_STATUS,
    envCall,
  };
}
export function updateSubscriptionStatus(data) {
  return {
    type: UPDATE_SUBSCRIPTION_STATUS,
    data,
  };
}
export function fetchProductStatusSuccess(productStatus) {
  return {
    type: FETCH_PRODUCT_STATUS_SUCCESS,
    payload: productStatus,
  };
}

export function fetchTestTokenFromProd() {
  return {
    type: FETCH_TEST_TOKEN_FROM_PROD,
  };
}

export function fetchTestTokenFromProdSuccess(testToken) {
  return {
    type: FETCH_TEST_TOKEN_FROM_PROD_SUCCESS,
    payload: testToken,
  };
}

export function resendEmailVerification() {
  return {
    type: RESEND_EMAIL_VERIFICATION,
  };
}

export function resendEmailVerificationSuccess(emailStatus) {
  return {
    type: RESEND_EMAIL_VERIFICATION_SUCCESS,
    payload: emailStatus,
  };
}

export function activateProductAction(data) {
  return {
    type: ACTIVATE_PRODUCTS,
    data,
  };
}

export function validateTokenAction() {
  return {
    type: VALIDATE_TOKEN,
  };
}

export function validateTokenSuccess(data) {
  return {
    type: VALIDATE_TOKEN_SUCCESS,
    data,
  };
}

export function enableLoaderAction() {
  return {
    type: ENABLE_LOADER,
  };
}

export function disableLoaderAction() {
  return {
    type: DISABLE_LOADER,
  };
}

export function fetchGammaTokenAction(data) {
  return {
    type: FETCH_GAMMA_TOKEN,
    data,
  };
}

export function updateGammaToken(data) {
  return {
    type: UPDATE_GAMMA_TOKEN,
    data,
  };
}

export function fetchQuickLinksDetailsAction() {
  return {
    type: FETCH_QUICK_LINKS,
  };
}

export function fetchQuickLinksSuccess(quickLinksData) {
  return {
    type: FETCH_QUICK_LINKS_SUCCESS,
    payload: quickLinksData,
  };
}

export function fetchPayoutDashboardConfig() {
  return {
    type: FETCH_PAYOUT_DASHBOARD_CONFIG,
  };
}

export function fetchPayoutDashboardConfigSuccess(data) {
  return {
    type: FETCH_PAYOUT_DASHBOARD_CONFIG_SUCCESS,
    payload: data,
  };
}

export function redeemVoucherCodeAction(data) {
  return {
    type: REDEEM_VOUCHER,
    data,
  };
}

export function subscribeWhatsappAction(data) {
  return {
    type: SUBSCRIBE_WHATSAPP,
    data,
  };
}

export function whatsappConsentAction(data) {
  return {
    type: WHATSAPP_CONSENT,
    data,
  };
}

export function checkPartnerConsentAction(data) {
  return {
    type: PARTNER_CONSENT,
    data,
  };
}

export function partnerTncAction(data) {
  return {
    type: PARTNER_TNC,
    data,
  };
}

export function freshdeskRedirectAction(data) {
  return {
    type: FRESHDESK_REDIRECT,
    data,
  };
}

export function fetchBannersAction(data) {
  return {
    type: FETCH_BANNERS,
    data,
  };
}

export function getMerchantDetailsAction(data) {
  return {
    type: GET_MERCHANT_DETAILS,
    data,
  };
}

export function fetchProductCardsAction(data) {
  return {
    type: FETCH_PRODUCT_CARDS,
    data,
  };
}

export function quickActivateProductAction(data) {
  return {
    type: QUICK_ACTIVATE_PRODUCT,
    data,
  };
}

export function fetchAMDetailsAction(data) {
  return {
    type: GET_ACCOUNT_MANAGER_DETAILS,
    data,
  };
}

export function setAMDetails(data) {
  return {
    type: SET_ACCOUNT_MANAGER_DETAILS,
    payload: data,
  };
}

export function activateEcomProductAction(data) {
  return {
    type: ACTIVATE_ECOM_PRODUCT_ACTION,
    data,
  };
}

export function fetchAggregatedProductStatusAction(data) {
  return {
    type: FETCH_AGGREGATED_PRODUCT_STATUS,
    data,
  };
}

export function generateHcFormAction(data) {
  return {
    type: FETCH_HELPCENTER_FORM,
    payload: data,
  };
}

export function generateHcFormSucccess(data) {
  return {
    type: FETCH_HELPCENTER_FORM_SUCCESS,
    payload: data,
  };
}

export function getFormDataSuccess(data) {
  return {
    type: FETCH_HC_FORM_DATA_SUCCESS,
    payload: data,
  };
}

export function openHcFormAction() {
  return { type: OPEN_HC_FORM };
}

export function closeHcFormAction() {
  return { type: CLOSE_HC_FORM };
}

/**
 * Action to trigger banner close api
 *
 * @param {Object} data - The data related to the banner.
 * @param {string} data.name - The name of the banner.
 */
export function closeBannerAction(data) {
  return { type: CLOSE_BANNER, payload: data };
}

export function getPayoutProtectInsightsAction(data) {
  return { type: PAYOUT_PROTECT_INSIGHTS, payload: data };
}

export function getPayoutProtectActiveStatusAction(data) {
  return { type: PAYOUT_PROTECT_ACTIVE_STATUS, payload: data };
}

export function getPayoutProtectInsightsSuccessAction(data) {
  return { type: PAYOUT_PROTECT_INSIGHTS_SUCCESS, payload: data };
}

export function getPayoutProtectActiveStatusSuccessAction(data) {
  return { type: PAYOUT_PROTECT_ACTIVE_STATUS_SUCCESS, payload: data };
}

export function activatePayoutProtectAction(data) {
  return { type: ACTIVATE_PAYOUT_PROTECT, payload: data };
}

export function activateRiskShieldAction(data) {
  return { type: ACTIVATE_RISKSHIELD, payload: data };
}

export function getRiskShieldActiveStatusAction(data) {
  return { type: RISK_SHIELD_ACTIVE_STATUS, payload: data };
}

export function getRiskShieldActiveStatusSuccessAction(data) {
  return { type: RISK_SHIELD_ACTIVE_STATUS_SUCCESS, payload: data };
}

export function getFeatureRequestAction(data) {
  return { type: FEATURE_REQUEST_STATUS, data };
}
